import { setCookie, getCookie, getRequestProtocol } from 'h3'

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

export default defineNuxtRouteMiddleware((to) => {
  const cfg = useRuntimeConfig().public
  const cookieKey = cfg.utmParamsCookieKey || 'cnclr_utm_params'

  const hasCookie = process.server
    ? (() => {
        const ev = useRequestEvent()
        return ev ? Boolean(getCookie(ev, cookieKey)) : false
      })()
    : document.cookie.split('; ').some(r => r.startsWith(cookieKey + '='))

  if (hasCookie) return

  const utm = {}
  UTM_KEYS.forEach((key) => {
    const raw = to.query?.[key]
    const val = Array.isArray(raw) ? raw[0] : raw
    if (typeof val === 'string' && val.trim()) utm[key] = val.trim()
  })

  if (!Object.keys(utm).length) return

  const value = JSON.stringify(utm)
  const maxAge = 60 * 60 * 24 * 90

  if (process.server) {
    const ev = useRequestEvent()
    if (ev) {
      const secure = getRequestProtocol(ev) === 'https'
      setCookie(ev, cookieKey, value, {
        domain: cfg.rootDomain || undefined,
        path: '/',
        sameSite: 'lax',
        secure,
        httpOnly: false,
        maxAge
      })
    }
  } else {
    const parts = [
      `${cookieKey}=${encodeURIComponent(value)}`,
      'Path=/',
      `Max-Age=${maxAge}`,
      'SameSite=Lax'
    ]
    if (location.protocol === 'https:') parts.push('Secure')
    if (cfg.rootDomain) parts.push(`Domain=${cfg.rootDomain}`)
    document.cookie = parts.join('; ')
  }
})
